var map = {
	"./DesignerGallery": "Uo64",
	"./DesignerGallery.js": "Uo64",
	"./Drawer": "cE1+",
	"./Drawer.js": "cE1+",
	"./DrawerMenu": "VaWK",
	"./DrawerMenu.js": "VaWK",
	"./DrawerMenuItem": "xUL3",
	"./DrawerMenuItem.js": "xUL3",
	"./ExpandableSiteSearch": "wXko",
	"./ExpandableSiteSearch.js": "wXko",
	"./FavoritesGallery": "FAlq",
	"./FavoritesGallery.js": "FAlq",
	"./Header": "80I8",
	"./Header.js": "80I8",
	"./HeaderBase": "NWkQ",
	"./HeaderBase.js": "NWkQ",
	"./HeaderToolbar": "tqRF",
	"./HeaderToolbar.js": "tqRF",
	"./MainMenuDrawer": "8vOe",
	"./MainMenuDrawer.js": "8vOe",
	"./MainMenuDrawerBKP": "3PoV",
	"./MainMenuDrawerBKP.js": "3PoV",
	"./NavLink": "aRnz",
	"./NavLink.js": "aRnz",
	"./Navigation": "QyHu",
	"./Navigation.js": "QyHu",
	"./NavigationRight": "Pkue",
	"./NavigationRight.js": "Pkue",
	"./NotFound": "X0fQ",
	"./NotFound.js": "X0fQ",
	"./PatternCategories": "SbcB",
	"./PatternCategories.js": "SbcB",
	"./SearchIcon": "tg+O",
	"./SearchIcon.js": "tg+O",
	"./SewpatGallery": "OIvz",
	"./SewpatGallery.js": "OIvz",
	"./SingleSewpatView": "3mWk",
	"./SingleSewpatView.js": "3mWk"
};
function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id])
		throw new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
	return __webpack_require__(id);
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = "X4TU";
module.exports = webpackContext;


//////////////////
// WEBPACK FOOTER
// ./src/components/header weak ^\.\/.*$
// module id = X4TU
// module chunks = 58